module.exports = __webpack_public_path__ + "static/media/pandaisia_full2.21cac41a.jpg";